<template>
  <div class="container">
    <div class="mt-5 mb-3 text-center">
      <h3 class="mb-3">FAQ</h3>
      <BootstrapIcon
        class="add-btn primary"
        icon="plus-circle"
        @click="showModal"
      />
    </div>
    <table class="table table-hover table-striped table-bordered align-middle">
      <caption>
        Question List
      </caption>
      <thead>
        <tr>
          <th scope="col">Question EN</th>
          <th scope="col">Question CH</th>
          <th scope="col">Answer EN</th>
          <th scope="col">Answer CH</th>
          <th scope="col">Option</th>
        </tr>
      </thead>
      <tbody>
        <tr :key="question._id" v-for="question in gardenQuestionData">
          <AdminFaqTable :question="question" />
        </tr>
      </tbody>
    </table>
    <ModalFaq v-if="displayModal" @close-modal-event="hideModal" />
  </div>
</template>
<script>
import { onMounted, computed } from "vue";
import store from "../../store";
import ModalFaq from "./ModalFaq.vue";
import AdminFaqTable from "./AdminFaqTable.vue";
export default {
  name: "AdminFaq",
  components: {
    ModalFaq,
    AdminFaqTable,
  },
  data() {
    return {
      displayModal: false,
    };
  },
  methods: {
    showModal() {
      this.displayModal = true;
    },
    hideModal() {
      this.displayModal = false;
    },
  },
  setup() {
    onMounted(() => {
      store.dispatch("fetchGardenQuestionData");
    });
    const gardenQuestionData = computed(() => store.state.gardenQuestionData);

    return {
      gardenQuestionData,
    };
  },
};
</script>
